var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptionSelector',{attrs:{"model":'jobCategory',"nextRoute":item => (item.verification_required ? 'CompanyPage' : 'JobPage')}})
}
var staticRenderFns = []

export { render, staticRenderFns }